import axiosClient from './axiosClient';

const customerController = {
  getCustomerById(token, pageSize = 1000, page = 0) {
    const url = `/api/customers?pageSize=${pageSize}&page=${page}`;
    return axiosClient.get(url, {
      headers: {
        Authorization: 'Bearer ' + token,
      },
    });
  },
  saveCustomer(token, customer) {
    const url = '/api/customer';
    const payload = customer;
    return axiosClient.post(url, payload, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
  deleteCustomer(token, customerId) {
    const url = `/api/customer/${customerId}`;
    return axiosClient.delete(url, {
      headers: {
        'X-Authorization': 'Bearer ' + token,
      },
    });
  },
};

export default customerController;
